import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScipyComponent } from './simple-icons-scipy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScipyComponent ],
    exports:      [ SimpleIconsScipyComponent ],
    bootstrap:    []
})
export class SimpleIconsScipyModule {}
